import { render, staticRenderFns } from "./HolidayEdit.vue?vue&type=template&id=3cebfa82"
import script from "../../../controllers/custom/holiday/holiday-edit.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/holiday/holiday-edit.js?vue&type=script&lang=js&external"
import style0 from "./HolidayEdit.vue?vue&type=style&index=0&id=3cebfa82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports